import { render } from "./AcceptDecline.vue?vue&type=template&id=493873c6"
import script from "./AcceptDecline.vue?vue&type=script&lang=js"
export * from "./AcceptDecline.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__